import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { requestCallback, updateStatus, getCallbackError } from '../../slices/callback';
import { callbackStatuses } from '../../../constants';

const getCurrentDate = () => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const today = new Date();
  const month = months[today.getMonth()];
  const day = today.getDate();
  const year = today.getFullYear();
  let hour = today.getHours();
  let minutes = today.getMinutes();
  // Hour is on 24-hour time (0<=hour<=23), reformat to 12-hour time (0<=hour<=12)
  if (hour > 12) {
    hour %= 12;
  }
  // If the time is 12:05, minutes would just be 5 and display time as 12:5, reformat
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  const date = `${month} ${day}, ${year},  ${hour}:${minutes}`;
  return date;
};

function* getCallbackStatusWorker({ payload: { phone, cruiseLineObject } }) {
  try {
    const cruiseLineId = cruiseLineObject.value;
    const url = `https://requestcallback.travelwitsapi.com/callback?vendorId=${cruiseLineId}&phoneNumber=${phone}`;

    const config = {
      method: 'get',
      url,
    };

    const { data } = yield call(axios, config);

    if (data) {
      const formattedDate = getCurrentDate();
      yield put(updateStatus({ newStatus: callbackStatuses.ON_HOLD, timeStamp: formattedDate }));
    } else {
      yield put(getCallbackError({ error: 'Failed to reach cruise line' }));
    }
  } catch (error) {
    yield put(getCallbackError({ error: `${error}` }));
  }
}

function* getCallbackStatusWatcher() {
  yield takeLatest(requestCallback.toString(), getCallbackStatusWorker);
}

export default getCallbackStatusWatcher;
